var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.94,
    height: 22.812,
    viewBox: "0 0 22.94 22.812",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8917",
    "data-name": "Group 8917",
    transform: "translate(-1095.527 -241.943)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2933",
    "data-name": "Path 2933",
    d: "M1098.524,244.526c0,.281,0,.544,0,.807,0,.459,0,.919.007,1.377a1.422,1.422,0,0,0,1.054,1.322,1.447,1.447,0,0,0,1.563-.526,1.479,1.479,0,0,0,.288-.9c0-.666,0-1.332,0-2,0-.021,0-.042,0-.072h11.114v.336c0,.6-.007,1.2,0,1.8a1.457,1.457,0,0,0,2.712.7,1.379,1.379,0,0,0,.2-.745c-.007-.346,0-.694,0-1.041v-1.062h.415c.615,0,1.23,0,1.845,0a.709.709,0,0,1,.74.756q0,2.334,0,4.668v5.395q0,1.519,0,3.039,0,2.887,0,5.775a2.535,2.535,0,0,1-.01.326.7.7,0,0,1-.707.608h-10.638l-3.2,0-5.634,0c-.669,0-1.339-.012-2.008,0a.766.766,0,0,1-.741-.745c.012-1.744.006-3.488.006-5.232v-7.088q0-1.536,0-3.072,0-1.845,0-3.691a.7.7,0,0,1,.745-.748q1.064,0,2.127,0Zm8.452,19.622h.163l3.148.005h2.149c.807,0,1.614-.005,2.421-.006.655,0,1.31.005,1.964.005a.651.651,0,0,0,.708-.709v-2.876q0-2.682,0-5.363,0-2.617,0-5.233a.662.662,0,0,0-.726-.726c-.713,0-1.426,0-2.139,0q-2.11,0-4.222-.007c-.709,0-1.418.007-2.127.007q-2.464,0-4.928-.006c-.608,0-1.216.006-1.823.007h-4.4a.65.65,0,0,0-.693.693v2.1q0,2.692,0,5.384,0,3.006,0,6.014a.639.639,0,0,0,.7.711c1.071,0,2.142,0,3.213,0,.977,0,1.954,0,2.931,0,.524,0,1.049,0,1.572-.005Z",
    transform: "translate(0 -0.346)",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2934",
    "data-name": "Path 2934",
    d: "M1115.881,244.582c0-.575,0-1.15,0-1.725a.852.852,0,0,1,.451-.8.82.82,0,0,1,.912.046.808.808,0,0,1,.365.691q0,1.371,0,2.744c0,.285.011.572-.016.855a.841.841,0,0,1-.8.716.858.858,0,0,1-.851-.564,1.027,1.027,0,0,1-.052-.307c-.005-.553,0-1.107,0-1.661Z",
    transform: "translate(-2.732 0)",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2935",
    "data-name": "Path 2935",
    d: "M1101.391,244.491c0,.619.01,1.237,0,1.855a.841.841,0,0,1-.678.749.866.866,0,0,1-.925-.416.936.936,0,0,1-.112-.457c0-1.125,0-2.249,0-3.375a.864.864,0,0,1,.82-.9.852.852,0,0,1,.9.824c0,.571,0,1.143,0,1.714Z",
    transform: "translate(-0.556 -0.001)",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2936",
    "data-name": "Path 2936",
    d: "M1112.15,260.906c0-.45-.007-.9,0-1.351.009-.481.2-.714.667-.724q1.417-.029,2.835,0a.624.624,0,0,1,.659.7q.015,1.373,0,2.746a.655.655,0,0,1-.7.716c-.915.018-1.831.017-2.746,0a.653.653,0,0,1-.716-.736C1112.143,261.807,1112.15,261.356,1112.15,260.906Z",
    transform: "translate(-2.231 -2.265)",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2937",
    "data-name": "Path 2937",
    d: "M1100.292,254.932c0-.435-.007-.87,0-1.3.009-.468.22-.717.669-.725q1.417-.025,2.833,0a.615.615,0,0,1,.654.693q.014,1.371,0,2.744a.638.638,0,0,1-.689.714c-.93.019-1.86.021-2.789,0-.455-.01-.67-.266-.68-.726S1100.292,255.4,1100.292,254.932Z",
    transform: "translate(-0.639 -1.469)",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2938",
    "data-name": "Path 2938",
    d: "M1108.291,252.894c.435,0,.869-.007,1.3,0,.53.01.777.247.782.764q.013,1.326,0,2.653a.666.666,0,0,1-.719.743q-1.371.026-2.743,0c-.475-.009-.7-.259-.7-.749q-.012-1.349,0-2.7a.619.619,0,0,1,.682-.708c.464-.017.929,0,1.394,0Z",
    transform: "translate(-1.434 -1.469)",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2939",
    "data-name": "Path 2939",
    d: "M1100.292,260.868c0-.45-.009-.9,0-1.351a.62.62,0,0,1,.665-.686q1.418-.026,2.836,0a.613.613,0,0,1,.655.693q.014,1.373,0,2.746a.645.645,0,0,1-.687.719q-1.394.029-2.791,0a.646.646,0,0,1-.68-.727C1100.285,261.8,1100.292,261.334,1100.292,260.868Z",
    transform: "translate(-0.639 -2.265)",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2940",
    "data-name": "Path 2940",
    d: "M1110.39,260.89c0,.45.007.9,0,1.351-.008.484-.232.741-.7.751q-1.373.026-2.746,0a.658.658,0,0,1-.71-.745q-.011-1.351,0-2.7a.628.628,0,0,1,.681-.717q1.395-.027,2.79,0c.462.009.676.247.687.711S1110.39,260.44,1110.39,260.89Z",
    transform: "translate(-1.436 -2.265)",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2941",
    "data-name": "Path 2941",
    d: "M1114.251,252.893c.435,0,.869-.009,1.3,0,.507.012.753.249.758.741q.013,1.349,0,2.7a.653.653,0,0,1-.7.718q-1.394.03-2.788,0c-.453-.01-.673-.262-.677-.725q-.013-1.371,0-2.744a.609.609,0,0,1,.66-.684c.479-.019.959,0,1.439,0Zm1.23.832h-2.49v2.492h2.49Z",
    transform: "translate(-2.231 -1.469)",
    fill: "#929292"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.e2cbaa12e7152a45258dc2beb1741d52.svg";
export { ForwardRef as ReactComponent };